class SizeChartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#SizeChartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setSizeChartIconAccessibility();
  }

  setSizeChartIconAccessibility() {
    // const cartLink = document.querySelector('#cart-icon-bubble');
    /*
    const cartLink =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('#cart-icon-text'); // Fallback to cart-icon-text
    */
    const sizeChartLink = document.querySelector('#size-chart-link');
    if (!sizeChartLink) return;

    sizeChartLink.setAttribute('role', 'button');
    sizeChartLink.setAttribute('aria-haspopup', 'dialog');
    sizeChartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(sizeChartLink);
    });
    sizeChartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(sizeChartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#SizeChartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    /*
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
    */
    const sizeChartLink = document.querySelector('#size-chart-link')

    return [
      {
        id: 'size-chart-drawer',
        selector: '#SizeChartDrawer',
      },
      {
        id: sizeChartLink, // Use the dynamically determined cart icon
      },
    ];

  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('size-chart-drawer', SizeChartDrawer);

/*
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
*/
/*
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const cartIcon = document.querySelector('#cart-icon-bubble')
      ? 'cart-icon-bubble'
      : 'cart-icon-text'; // Fallback to cart-icon-text if cart-icon-bubble is not available

    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: cartIcon,
        section: cartIcon, // Use dynamically selected cart icon
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
*/